import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ id, text, className, handleCheckboxChanged, isChecked }) => {
    const [isCheckBoxChecked, setChecked] = useState(isChecked);

    useEffect(() => {
        setChecked(isChecked);
    }, [isChecked]);

    const onCheckboxChanged = () => {
        setChecked(!isCheckBoxChecked);
        handleCheckboxChanged(!isCheckBoxChecked);
    };

    return (
        <div className={`amplify-checkbox ${className}`}>
            <label htmlFor={`amplify-checkbox-${id}`}>
                <input
                    id={`amplify-checkbox-${id}`}
                    type="checkbox"
                    tabIndex="0"
                    checked={isCheckBoxChecked}
                    onChange={onCheckboxChanged}
                />
                <div className="faux-input" />
                {text && <span>{text}</span>}
            </label>
        </div>
    );
};

Checkbox.defaultProps = {
    text: null,
    id: '',
    className: '',
    handleCheckboxChanged: () => {},
    isChecked: false,
};

Checkbox.propTypes = {
    text: PropTypes.string,
    id: PropTypes.string,
    className: PropTypes.string,
    handleCheckboxChanged: PropTypes.func,
    isChecked: PropTypes.bool,
};

export default Checkbox;
